module.exports = __webpack_public_path__ + "static/media/concept-hero-2.a976cd05.jpg";